import React, { Component } from 'react';
import getContract, { getOwnerContract } from '../../services/contract';
import getTokenContract from '../../services/tokenContract'
import { ethers } from 'ethers';
import levelPrices from '../../services/levelPrice';
import getWallet from '../../services/wallet';
import Slot from './tree/slot';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

class ChangeWalletOwner extends Component {

    state = {
        newAddress: '',        
        position: 0
    };

    handleUpdate = async () => {
        const wallet = await getWallet();
        if(wallet.isReadOnly) {
            alert("Please connect your wallet");
            return;
        }
        
        const contract = await getOwnerContract();
        if(this.state.position == 1) {
            const promise = contract.owner1c(this.state.newAddress);
            try {
                await toast.promise(
                        promise,
                        {
                        pending: `Updating Wallet 1`,
                        success: 'Wallet updated',
                        error: 'failed'
                        },
                        
                    )
            } catch (error) {
                alert(error.reason);
            }
        } else if (this.state.position == 2) {
            const promise = contract.owner2c(this.state.newAddress);
            try {
                await toast.promise(
                        promise,
                        {
                        pending: `Updating Wallet 2`,
                        success: 'Wallet updated',
                        error: 'failed'
                        },
                        
                    )
            } catch (error) {
                alert(error.reason);
            }
        } else if (this.state.position == 3) {
            const promise = contract.owner3c(this.state.newAddress);
            try {
                await toast.promise(
                        promise,
                        {
                        pending: `Updating Wallet 3`,
                        success: 'Wallet updated',
                        error: 'failed'
                        },
                        
                    )
            } catch (error) {
                alert(error.reason);
            }
        } else if (this.state.position == 4) {
            const promise = contract.owner4c(this.state.newAddress);
            try {
                await toast.promise(
                        promise,
                        {
                        pending: `Updating Wallet 4`,
                        success: 'Wallet updated',
                        error: 'failed'
                        },
                        
                    )
            } catch (error) {
                alert(error.reason);
            }
        } else if (this.state.position == 5) {
            const promise = contract.owner5c(this.state.newAddress);
            try {
                await toast.promise(
                        promise,
                        {
                        pending: `Updating Wallet 5`,
                        success: 'Wallet updated',
                        error: 'failed'
                        },
                        
                    )
            } catch (error) {
                alert(error.reason);
            }
        }
    }

    render() { 
        return (
            <>
            
            <div className="flex flex-shrink w-full flex-col items-center min-h-screen bg-main pt-20 sm:pt-14">
            <ToastContainer 
                    position="top-right"
                    theme="colored"
                    autoClose={10000}
                /> <ToastContainer />
                    <div className="flex relative flex-1 py-2 pt-8.5 flex-col justify-between w-full px-10 sm:px-0 sm:pt-7.5">
                        {/* Top Panel, Matrix levels and all activies inside below div */}
                        <div className="flex flex-col w-full space-y-10 sm:space-y-5">

                            {/* Top panel Partners, Team, Profit ration, Profits View inside below div */}
                            <div className="flex w-full mt-15 sm:mt-5 sm:px-5">
                            <div
                                className="flex flex-1 flex-col items-start mr-10 sm:mr-0 sm:items-stretch sm:max-w-full sm:p-5">
                                <div className="flex flex-col sm:flex-1">
                                        <span className="inline-block text-two-half text-white mb-10 sm:mb-7.5 sm:text-2xl">
                                            Update Owner Wallet
                                        </span>
                                        <p className="inline-block text-white mb-10 sm:mb-7.5 sm:text-2xl">
                                            Caution: You can change only your wallet by enter your wallet position 
                                        </p>
                                    <div className="flex flex-col mb-10 sm:mb-7.5">
                                        <div className="w-full relative flex flex-col flex-grow-0 flex-shrink-0"><label
                                                className="mb-2.5 text-white-500 sm:text-sm">Enter Position</label>
                                            <div className="w-full relative">
                                                <input style={{background: '#303031'}}
                                                    className="w-full bg-white-100 border-2 border-transparent rounded-mini py-3 px-5 text-white outline-none focus:border-2 focus:border-main-blue false"
                                                    onChange={(e) => this.setState({ position: e.target.value })} value={this.state.position} type="number" placeholder="Wallet position" id="referralInput" 
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="flex flex-col mb-10 sm:mb-7.5">
                                        <div className="w-full relative flex flex-col flex-grow-0 flex-shrink-0"><label
                                                className="mb-2.5 text-white-500 sm:text-sm">Enter New Address</label>
                                            <div className="w-full relative">
                                                <input style={{background: '#303031'}}
                                                    className="w-full bg-white-100 border-2 border-transparent rounded-mini py-3 px-5 text-white outline-none focus:border-2 focus:border-main-blue false"
                                                    onChange={(e) => this.setState({ newAddress: e.target.value })} value={this.state.newAddress} type="text" placeholder="New Address" id="referralInput" 
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="flex">
                                    <button style={{background: 'white'}}
                                        className="flex justify-center items-center text-center text-base font-bold text-black rounded-mini sm:text-sm outline-none px-5 py-4 bg-blue-600 hover:bg-blue-400 active:bg-active-red-600 mt-10 py-5 !px-10 sm:py-5 sm:mt-7.5"
                                        onClick={this.handleUpdate} id="nextButton" >Update </button>
                                </div>
                            </div>
                            </div>
                            {/* Top panel Partners, Team, Profit ration, Profits View inside above div */}

                        </div>
                        {/* Top Panel, Matrix levels and all activies inside above div */}
                    </div>
            </div>
            </>
        );
    }
}
 
export default ChangeWalletOwner;